import { render, staticRenderFns } from "./SfProperty.vue?vue&type=template&id=57fa1b58&"
import script from "./SfProperty.vue?vue&type=script&lang=js&"
export * from "./SfProperty.vue?vue&type=script&lang=js&"
import style0 from "./SfProperty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports